import { Link } from "react-router-dom";
import { Typography, Card, Badge } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { getIconByDatastoreType } from "../DatastoreImage";
import { DatastoreTypeEnum } from "../../types";
import { Integration } from "@/types/integration";

interface DbtCoreCardProps {
  integration: Integration;
}

const DbtCoreCard = ({ integration }: DbtCoreCardProps): JSX.Element => {
  // Get all environment names for display
  const environmentNames =
    integration.environments?.map(env => env.name).join(", ") || "No environments";

  // Get the first environment for linking
  const firstEnvironment = integration.environments?.[0]?.name;

  const linkPath = firstEnvironment
    ? `/settings/datastores/dbt-core/${integration.id}/${firstEnvironment}`
    : `/settings/datastores/dbt-core/${integration.id}`;

  const isDeleted = integration.is_deleted;

  const card = (
    <Card
      className={
        isDeleted
          ? "al-opacity-60 al-transition-shadow"
          : "al-cursor-pointer hover:al-shadow-md al-transition-shadow"
      }
    >
      <Stack direction="row" justify="between" align="center" className="al-mb-2 al-px-5 al-pt-4">
        <Stack direction="row" justify="between" align="center">
          {getIconByDatastoreType({
            datastoreType: DatastoreTypeEnum.DBT_CORE,
            className: "al-rounded al-w-14 al-h-14",
          })}
          <div className="al-ms-2">
            <Typography variant="section-heading">{integration.name}</Typography>
            <Typography size="sm" className="al-text-brand">
              dbt Core
            </Typography>
          </div>
        </Stack>
      </Stack>

      <Stack
        direction="row"
        justify="between"
        align="center"
        className="al-mb-2 al-text-gray al-px-5"
      >
        <Typography size="sm" className="al-text-muted-foreground">
          {environmentNames}
        </Typography>
      </Stack>

      <Stack
        direction="row"
        align="center"
        className="al-py-3 al-px-5 al-rounded-b-[20px] al-bg-[#f5f6f7] al-row-[3/4]"
      >
        <Stack direction="row" justify="between" align="center" className="al-w-full">
          <Stack direction="row" align="center" gap="sm">
            <Typography size="xs" className="al-text-gray">
              {integration.environments?.length || 0} environment
              {(integration.environments?.length || 0) !== 1 ? "s" : ""}
            </Typography>
            {isDeleted ? (
              <Typography size="xs" className="al-text-muted-foreground">
                Scheduled for deletion (typically takes up to 24 hours)
              </Typography>
            ) : (
              integration.environments &&
              integration.environments.length > 0 && (
                <Badge variant="outline" className="al-text-xs">
                  Active
                </Badge>
              )
            )}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );

  if (isDeleted) {
    return card;
  }

  return (
    <Link to={linkPath} className="al-block">
      {card}
    </Link>
  );
};

export default DbtCoreCard;
